import { DeviceType } from '../store/models/Project';

export const transformDeviceTypes = ({ AHS, NZM }: DeviceType) => {
  return Object.fromEntries(
    Object.values({ AHS, NZM })
      .flat()
      .map((str) => [str, str.replace(/_/g, ' ')]),
  );
};
